<template>
  <div class="login-page items-center justify-center">
    <v-card :loading="loading" class="mx-auto item-card">
      <warnningComponent
        v-bind:textInfo.sync="textWarning"
        v-bind:typestatus.sync="typeWarning"
        v-bind:alert.sync="showWarnnig"
      ></warnningComponent>
      <!-- <v-card-actions>
        <v-btn large icon :to="{ path: `/companySelection` }">
          <v-icon color="grey lighten-1">mdi-chevron-left</v-icon>
        </v-btn>
      </v-card-actions> -->

      <div class="logo-welcome mb-5">
        <v-img :src="company.companies[0].logo"></v-img>
      </div>
      <div class="my-10">
        <v-card-title
          primary-title
          class="headline justify-center pa-0 font-weight-bold"
          >WELCOME</v-card-title
        >
        <p class="text-center">{{ company.username }}</p>
      </div>
      <!-- <div class="company-name">
        <div class="img-company">
          <v-img :src="company.companies[0].logo"></v-img>
        </div>
        <span
          class="font-weight-bold"
          :style="{ color: company.companies[0].themeColor }"
        >{{company.companies[0].title}}</span>
      </div>-->

      <!-- <v-list-item three-line>
        <v-list-item-content>
        <v-list-item-title
            class="mb-1 titleCard"
            :style="{ color: company.companies[0].themeColor }"
          >{{company.companies[0].title}}</v-list-item-title>
          <v-list-item-subtitle class="description">กรุณากรอกรหัสผ่านที่ใช้ภายในองค์กรของท่าน</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>-->
      <!--<v-text-field :rules="rules" :value="company.companies[0].title" disabled outlined rounded></v-text-field>-->
      <v-form
        class="px-5"
        ref="form"
        v-model="valid"
        v-on:submit.prevent="validate"
      >
        <!-- <v-text-field
                :value="userPassword"
                label="กรอกรหัสผ่าน"
                autocomplete="password"
                hint="Your password passed! Password rules are not meant to be broken!"
                @click:append="() => (value = !value)"
                name="password"
                :rules="passwordRules"
                id="password"
                :append-icon="!value ? 'mdi-eye' : 'mdi-eye-off'"
                :type="value ? 'password' : 'text'"
                @input="_=>userPassword=_"
        ></v-text-field>-->
        <div class="discreption mb-3">
          <p class="subtitle-1 mb-0 text--disabled">
            กรุณากรอกรหัสผ่านที่ใช้ภายในองค์กรของท่าน
          </p>
        </div>

        <div class="text-center">
          <v-text-field
            outlined
            :value="userPassword"
            name="password"
            id="password"
            :type="value ? 'text' : 'password'"
            @click:append="() => (value = !value)"
            :append-icon="!value ? 'mdi-eye' : 'mdi-eye-off'"
            autocomplete="password"
            @input="(_) => (userPassword = _)"
            :rules="passwordRules"
            placeholder="Password"
            required
            clearable
            class="iconInput"
          ></v-text-field>

          <v-btn
            :disabled="!valid"
            class="login-button white--text"
            :color="isVKNOWS ? '#4BD0A0' : 'primary'"
            @click="validate"
            >Login</v-btn
          >
        </div>
        <div style="float: right; padding-right: 20px">
          <p class="mt-2 size font-weight-light">
            <a @click="switchToForgetPassword">
              <span
                style="color: #1a3f7d !important"
                class="txt-hyperLink caption font-weight-bold"
                >Forget Password</span
              >
            </a>
          </p>
        </div>
      </v-form>
    </v-card>
    <v-dialog v-model="cantAccess" persistent max-width="450">
      <v-card>
        <v-card-title class="headline"
          >คุณไม่มีสิทธิ์เข้าถึงเว็บไซต์นี้</v-card-title
        >
        <v-card-text>
          <p>กลับไปยังหน้าเข้าสู่ระบบ</p>
        </v-card-text>
        <!-- <v-card-text v-if="actionCourses.active == true">
            <p class="font-weight-bold">
              <strong class="red--text">คำเตือน!</strong>
              หลังจากย้ายคอร์สไปยังถังขยะแล้ว คอร์สจะถูกหยุดเผยแพร่โดยอัตโนมัติ
            </p></v-card-text
          > -->
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            elevation="0"
            class="px-7 ma-2 subtitle-2 font-weight-light"
            color="error darken-1"
            @click="goToLogin()"
            ><p class="pa-0 ma-0">ตกลง</p>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import { login, getInfo, logout } from '@/service/account/login';
import { checkDevice } from '@/helper/checkDevice';
import warnningComponent from '../../components/warningAlert.vue';
import { isNerdOf, isVKNOWS, isClsedo } from "../../helper/domain"

export default {
  name: 'enter-password',
  components: {
    warnningComponent,
  },
  data() {
    return {
      dialog: false,
      value: false,
      loading: false,
      valid: true,
      company: JSON.parse(localStorage.getItem('company')),
      passwordRules: [(v) => !!v || 'Password is required'],
      textWarning: '',
      typeWarning: '',
      showWarnnig: false,
      userPassword: '',
      cantAccess: false,
    };
  },
  computed: {
    isVKNOWS() {
      return isVKNOWS();
    },
    isNerdOf() {
      return isNerdOf();
    },
    isClsedo() {
      return isClsedo();
    },
  },

  methods: {
    async validate() {
      this.$refs.form.validate();
      this.loading = true;
      this.login();
    },
    async login() {
      let device = checkDevice();
      let result = await login({
        id: this.company._id,
        password: this.userPassword,
        platform: device.platform,
        osversion: device.osversion,
        device: device.device,
      });

      if (result.data.status == false) {
        this.loading = false;

        this.warnnig('รหัสผ่านไม่ถูกต้อง', 'warning');
        return;
      } else {
        this.loading = false;

        await localStorage.setItem('x-session-token', result.data.result.token);
        await localStorage.setItem('expWeb', result.data.result.endTime);

        let resultInfo = await getInfo();

        if (
          resultInfo.info.isTeacher !== 'y' &&
          !resultInfo.info.permission.adminCompany
        ) {
          await logout();
          await this.$store.commit('clear');
          await localStorage.clear();
          this.cantAccess = true;
          return;
        }

        await localStorage.removeItem('companies');
        await this.$store.commit('setTheme', resultInfo.info);
        await this.$router.replace({ path: '/' });
      }
    },
    async switchToForgetPassword() {
      await this.$router.replace({ path: '/forgetpassword' });
    },

    warnnig(text, type) {
      (this.textWarning = text),
        (this.typeWarning = type),
        (this.showWarnnig = true);
    },

    async goToLogin() {
      await this.$router.replace({
        path: '/login',
      });
    },
  },
};
</script>
<style scoped>
.logo-welcome {
  width: 20%;
  /* width: 180px; */
  margin: 0 auto;
}
.login-page {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.item-card {
  /* width: 30%; */
  min-height: 300px;
  padding: 48px 0 0;
}
.rowCard {
  height: 400px;
  margin-top: 20px;
}
.titleCard {
  font-weight: bold;
  margin-top: 10px;
  text-align: center;
  font-size: 30px;
}
.formPassword {
  margin-left: 20px;
  margin-right: 20px;
}
.login-button {
  margin-bottom: 20px;
  width: 100%;
}
.forgotPass {
  margin-right: 100px;
}
.description {
  text-align: center;
}
.company-name {
  display: flex;
  min-width: 300px;
  width: 125px;
  margin: 0 auto;
  justify-content: center;
  border: 1px solid #e0e0e0;
  padding: 5px 0;
  border-radius: 30px;
}
.img-company {
  width: 25px;
  margin-right: 10px;
}
@media only screen and (min-width: 1025px) and (max-width: 1795px) {
  .item-card {
    width: 30%;
  }
}
@media only screen and (min-width: 1796px) {
  .item-card {
    width: 25%;
  }
}

@media only screen and (max-width: 768px) {
  .item-card {
    width: 100%;
    /* min-height: 90%; */
    padding: 36px 0 0;
  }
  .login-page {
    height: 100%;
    align-items: unset;
  }
}
@media only screen and (min-width: 769px) and (max-width: 1024px) {
  .item-card {
    width: 45%;
    min-height: 560px;
  }

  .login-page {
    height: 100%;
    align-items: center;
  }
}
.txt-hyperLink {
  text-decoration: underline;
}
</style>
<style lang="scss">
.iconInput {
  .v-input__control > .v-input__slot > .v-input__append-inner {
    margin-left: auto !important;
    padding-left: 4px !important;
    margin-top: 6px !important;
  }
}
</style>